export default "__VITE_ASSET__mHgfWkMK__"